import {
  AfterViewInit,
  Component, Directive, ElementRef, EventEmitter, forwardRef,
  Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewContainerRef
} from '@angular/core';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DateButton, DlDateTimePickerComponent} from '../date-picker/dl-date-time-picker';

import * as _moment from 'moment';
import {unitOfTime} from 'moment';
import {DatePipe} from '@angular/common';

let moment = _moment;

if ('default' in _moment) {
  moment = _moment['default'];
}

/**
 * Use text fields in forms to help people enter, select, and search for text. Text fields are normally found within a form but can also
 * be part of a modal, search, or card. Common text input types include: usernames, descriptions, URLs, emails, addresses,
 * and plain text searches.
 */
@Component({
  selector: 'clo-datepicker',
  templateUrl: './date-input.html',
  styleUrls: ['./input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CloDatePicker),
      multi: true
    }
  ]

})

export class CloDatePicker implements ControlValueAccessor {

  /**
   * Boolean value for disabling the field
   */
  @Input() disabled: boolean;

  /**
   * Placeholder Text
   */
  @Input() placeholder: string;

  /**
   * Error Message
   */
  @Input() errorMessage = '';

  /**
   * Boolean for whether the field is required
   *
   */
  @Input() required: boolean;

  /**
   * Boolean for whether the field is readOnly
   *
   */
  @Input() readOnly: boolean;

  @Input() minDate: Date;
  @Input() maxDate: Date;

  @Input() inputId: string;

  @Input('value')
  val: string | Date;
  @ViewChild('dateInput', {static: false}) dateInput: ElementRef;
  @ViewChild('datedropdown', {static: false}) dateDropdown: ElementRef;
  @Output() change = new EventEmitter();

  get value() {
    return this.val;
  }

  set value(val) {
    if (typeof this.val === 'string') {
      this.val = new Date(val);
    } else {
      this.val = val;
    }
    // console.log('Value Changed');
    this.onChange(val);
    this.onTouched();
  }

  // Both onChange and onTouched are functions
  onChange: any = () => { };
  onTouched: any = () => { };
  setDisabled: any = () => { };

  // We implement this method to keep a reference to the onChange
  // callback function passed by the forms API
  registerOnChange(fn) {
    this.onChange = fn;
  }
  // We implement this method to keep a reference to the onTouched
  // callback function passed by the forms API
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  // This is a basic setter that the forms API is going to use
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  centerInScreen(e) {
    console.log('Center Datepicker in screen');

    if (e) {
      console.log(this.dateDropdown.nativeElement);
      this.dateDropdown.nativeElement.scrollIntoView( {behavior: 'smooth', block: 'start', inline: 'nearest'});
    }

  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  blur(e) {
    // this.dateInput.nativeElement.trigger(e);
  }

  startDatePickerFilter = (dateButton: DateButton, viewName: string) => {
    const notBeforeMinDate = (this.minDate) ?
      dateButton.value >= moment(this.minDate).startOf(viewName as unitOfTime.StartOf).valueOf() : true;
    const notAfterMaxDate = (this.maxDate) ?
      dateButton.value <= moment(this.maxDate).endOf(viewName as unitOfTime.StartOf).valueOf() : true;

    return (notBeforeMinDate && notAfterMaxDate);
  }

  updateValue(e, date = undefined) {
    const pipe = new DatePipe('en-US');
    const dateInput = this.dateInput.nativeElement;
    const dateString = (date) ? pipe.transform(date, 'MM/dd/yyyy') : dateInput.value;
    date = date || new Date(dateString);
    if (date && dateString.match(/([0-9]{2}\/){2}[0-9]{4}$/)) {
      if (!this.checkMaxDate(date)) {
        this.value = this.maxDate;
        dateInput.value = pipe.transform(this.maxDate, 'MM/dd/yyyy');
      } else if (!this.checkMinDate(date)) {
        this.value = this.minDate;
        dateInput.value = pipe.transform(this.minDate, 'MM/dd/yyyy');
      } else {
        this.value = date;
      }

    } else if (date && dateString.match(/([0-9]{2}\/)([0-9]{2})$/)) {
      const newDate = new Date(date + '/' + new Date().getFullYear());
      this.value = newDate;
      dateInput.value = pipe.transform(newDate, 'MM/dd/yyyy');
      this.updateValue(e);
    } else {
      this.value = undefined;
      dateInput.value = '';
    }
  }


  private checkMaxDate(date: Date) {
    const momentOfDate = moment(date);
    return (this.maxDate) ?
      momentOfDate.valueOf() <= moment(this.maxDate).endOf('day').valueOf() : true;
  }

  private checkMinDate(date: Date) {
    const momentOfDate = moment(date);
    return (this.minDate) ?
      momentOfDate.valueOf() >= moment(this.minDate).endOf('day').valueOf() : true;
  }

  updateInput(e) {
    let date = e._value;
    this.updateValue(e, date);
    this.change.emit(this.value);
  }

}
